import {
  callApi
} from "./Api";

export const GET_INSIGHTS_SEARCH_RESULTS = 'GET_INSIGHTS_SEARCH_RESULTS'
export const GET_ALL_INSIGHTS_SEARCH_RESULTS = 'GET_ALL_INSIGHTS_SEARCH_RESULTS'
export const RESET_DATA = 'RESET_DATA'

export const resetData = () => ({type: RESET_DATA})

export const getSearch = (obj) => (dispatch, getState) => {
  const url = 'insights/stats/insights-files';
  callApi(dispatch, getState, GET_INSIGHTS_SEARCH_RESULTS, url, {
    method: 'POST',
    body: JSON.stringify(obj)
  })
}

export const getAllSearch = (obj) => (dispatch, getState) => {
  const url = 'insights/stats/insights-files';
  callApi(dispatch, getState, GET_ALL_INSIGHTS_SEARCH_RESULTS, url, {
    method: 'POST',
    body: JSON.stringify(obj)
  })
}


// WEBPACK FOOTER //
// ./src/actions/InsightsInfo.js